export function getItemFromLocalStorage(key: string) {
  const json = localStorage.getItem(key);
  return json ? JSON.parse(json) : undefined;
}
